<template>
    <div>
        <a-list-item-meta
            item-layout="vertical"
            :title="title">
            <span :class="cssDescription" slot="description">{{description}}</span>
            <a-avatar v-if="item.status == 'APPROVED'" slot="avatar" style="background-color: #EDF9E7">
                <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-success" fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z"/>
                </svg>
            </a-avatar>
            <a-avatar v-if="item.status == 'APPLIED'" slot="avatar" style="background-color: #FFFCE7">
                <strong class="text-warning">
                    !
                </strong>
            </a-avatar>
            <a-avatar v-if="item.status == 'MISSED'" slot="avatar" style="background-color: #FEE9EA">
                <strong class="text-danger">
                    !
                </strong>
            </a-avatar>
            <a-avatar v-if="item.status == 'REJECTED'" slot="avatar" style="background-color: #FEE9EA">
                <svg width="10" height="10" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd"  d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z"/></svg>
            </a-avatar>   
            <a-avatar v-if="item.status == 'CANCELLED'" slot="avatar" style="background-color: #FEE9EA">
                <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd" d="M5 10C5 9.44772 5.44772 9 6 9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11L6 11C5.44772 11 5 10.5523 5 10Z"/>
                </svg>
            </a-avatar>
            <a-avatar v-if="item.status == 'COMPLETE'" slot="avatar" style="background-color: #EDF9E7">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 78.369 78.369" style="enable-background:new 0 0 78.369 78.369;">
                    <path class="fill-success" fill-rule="evenodd" clip-rule="evenodd" d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
                            c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
                            C78.477,17.894,78.477,18.586,78.049,19.015z"/>

                </svg>
            </a-avatar>
            <a-avatar v-if="item.status == 'RESCHEDULED'" slot="avatar" style="background-color: #FFFCE7">
                <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512"  style="enable-background:new 0 0 78.369 78.369;">
                    <path class="fill-warning" fill-rule="evenodd" clip-rule="evenodd" d="M478,256A222,222,0,0,1,99,413,220.55,220.55,0,0,1,34,256H63.92c0,105.91,86.17,192.08,192.08,192.08S448.08,361.91,448.08,256,361.91,63.92,256,63.92A191.8,191.8,0,0,0,116.58,124H175v29.92H70V49H99.93v49.3A221.93,221.93,0,0,1,478,256ZM250,139V280H373V250H280V139Z"/>

                </svg>
            </a-avatar>                        
        </a-list-item-meta>
        <div class="" style="margin-left: 47px; margin-top: 5px;">
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; ">
                    <a-avatar
                        slot="avatar"
                        size="small"
                        shape="square"
                        :src="officialImageUrl"
                        style="margin-right: 10px;"
                    />
                    <span style="font-size: 13px;font-weight: 600;color: #141414;">
                        {{ officialName }}
                    </span>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import { DateHelpers } from '../../helpers/DateHelpers';
import { mapState } from 'pinia';
import { useLocaleStore } from "../../stores/locale-store.js";

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState(useLocaleStore, [ 'locale' ]),
        description() {
            if (this.item) {
                if (this.item.status == 'APPLIED') {
                    return "Approval Pending";
                } else if (this.item.status == 'APPROVED') {
                    return "Will Take Place on : " + DateHelpers.formatToReadableDate(this.item.dateTs) + " " + DateHelpers.formatToReadableTime(this.item.hour, this.item.min);
                } else if (this.item.status == 'REJECTED') {
                    return "This request was declined";
                } else if (this.item.status == 'RESCHEDULED') {
                    return "Rescheduled on : " +  this.item.date + " " + this.item.hour + ":" + this.item.min;
                } else if (this.item.status == 'CANCELLED') {
                    return "This meeting was cancelled";
                } else if (this.item.status == 'COMPLETE') {
                    return "This meeting took place on : " + DateHelpers.formatToReadableDate(this.item.dateTs) + " " + DateHelpers.formatToReadableTime(this.item.hour, this.item.min);
                } else if (this.item.status == 'MISSED') {
                    return "You missed this meeting on : " + DateHelpers.formatToReadableDate(this.item.dateTs) + " " + DateHelpers.formatToReadableTime(this.item.hour, this.item.min);
                }
                return '';
            }
        },
        cssDescription() {
            if (this.item) {
                if (this.item.status == 'APPLIED') {
                    return 'text-warning';
                } else if (this.item.status == 'APPROVED') {
                    return 'text-success';
                } else if (this.item.status == 'REJECTED') {
                    return 'text-danger';
                } else if (this.item.status == 'RESCHEDULED') {
                    return 'text-warning';
                } else if (this.item.status == 'CANCELLED') {
                    return 'text-danger';
                } else if (this.item.status == 'COMPLETE') {
                    return 'text-success';
                } else if (this.item.status == 'MISSED') {
                    return 'text-danger';
                }
                return '';
            }
        },
        title() {
            if (this.item && this.item.topic) {
                if (this.item.topic.length > 43)
                    return this.item.topic.substring(0, 40) + '...';
                return this.item.topic;
            }
            return '';
        },
        officialImageUrl() {
            if (this.item && this.item.official && this.item.official.imageUrl && this.item.official.imageUrl.length > 0)
                return this.item.official.imageUrl;
            return '/images/default-avatar.jpg';
        },
        officialName() {
            if (this.locale == 'bn')
                if (this.item && this.item.official && this.item.official.nameBn)
                    return this.item.official.nameBn;
            if (this.locale == 'en')
                if (this.item && this.item.official && this.item.official.name)
                    return this.item.official.name;
            return '';
        },
    }
}
</script>